"use client";

import dynamic from "next/dynamic";

import { MOCKS_ENABLED } from "@/mocks/flag";

import { CognitoAuthProvider } from "../CognitoWrapper/CognitoAuthWrapper";

/**
 * The only reference to src/mocks/** from production code, and it sits behind a
 * build-time literal.
 *
 * When NEXT_PUBLIC_API_MOCKING is not "enabled", MOCKS_ENABLED folds to false, the
 * ternary collapses to null, and the dynamic-import edge — and with it the entire
 * mock module graph — is never emitted into the bundle.
 *
 * `ssr: false` is load-bearing: MockProvider reads localStorage and window at mount
 * and layout.tsx is force-dynamic, so SSR genuinely runs.
 */
const MockProvider = MOCKS_ENABLED
  ? dynamic(() => import("@/mocks/MockProvider").then((m) => m.MockProvider), {
      ssr: false,
      loading: () => null,
    })
  : null;

export function AuthGateway({ children }: { children: React.ReactNode }) {
  if (MockProvider) return <MockProvider>{children}</MockProvider>;
  return <CognitoAuthProvider>{children}</CognitoAuthProvider>;
}
